import { Box, Card, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import NewCardcomp from "../../../components/card/NewCardcomp";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import EnrollDetails from "../popupComponent/EnrollDetails";
import CustomPopup from "../../../components/CustomPopup";
import { useGetTokenOrLogout } from "../../../utils/token";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function StudentLevelWiseData({
  statusLoading,
  trainingStstusData,
}) {
  const userId = localStorage.getItem("userId");

  const getTokenOrLogout = useGetTokenOrLogout();
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const [state, setState] = React.useState({
    series: [],
    options: {
      chart: {
        type: "donut",
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 90,
          offsetY: 10,
          customScale: 1.1, // Adjust this value if you need to change the donut's inner size
        },
      },
      colors: ["#FF4B4B", "#01BE85", "#FABA3A"],
      grid: {
        padding: {
          bottom: -100,
        },
      },
      legend: {
        show: false, // This hides the legend
      },
      labels: ["Not Started", "Ongoing", "Training Completed"], // Custom labels for each segment
      tooltip: {
        y: {
          formatter: (value, { seriesIndex }) => {
            // const labels = ['Not Starte', 'Ongoing', 'Training Completed'];
            return `${value}`; // Custom text with value
          },
          style: {
            fontSize: "10px", // Decrease tooltip font size
          },
        },
      },
      dataLabels: {
        style: {
          fontSize: "10px", // Decrease data label font size
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });

  // Update the series when trainingStstusData changes
  useEffect(() => {
    if (trainingStstusData) {
      setState((prevState) => ({
        ...prevState,
        series: [
          trainingStstusData.not_started || 0,
          trainingStstusData.ongoing || 0,
          trainingStstusData.training_completed || 0,
        ],
      }));
    }
  }, [trainingStstusData]);

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),

      filter_type: cardFilter,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}trainerdashboard/fetch-training-status-detailed-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("User not found", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 405) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };
  return (
    <>
      <LoaderComp isLoading={detailsLoading} />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <NewCardcomp>
            <Typography variant="h5" textAlign="center">
              {" "}
              Students Training Status
            </Typography>
          </NewCardcomp>
        </Grid>

        {statusLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={2}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid item xs={12}>
            <NewCardcomp height="350px">
              <Grid container mt={1} spacing={1}>
                <Grid item xs={12}>
                  <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="donut"
                    height={230}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  display="flex"
                  direction="row"
                  alignItems="center"
                  gap={1}
                >
                  <Box
                    sx={{
                      bgcolor: "#FF4B4B",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                    }}
                  ></Box>
                  <Typography variant="h6">Not Started</Typography>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sx={{ cursor: "pointer" }}
                  onClick={() => getCardMoreInfo("Not Started", "not_started")}
                >
                  <Typography variant="h6">
                    {trainingStstusData?.not_started}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={6}
                  display="flex"
                  direction="row"
                  alignItems="center"
                  gap={1}
                >
                  <Box
                    sx={{
                      bgcolor: "#01BE85",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                    }}
                  ></Box>
                  <Typography variant="h6">Ongoing</Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{ cursor: "pointer" }}
                  onClick={() => getCardMoreInfo("Ongoing", "ongoing")}
                >
                  <Typography variant="h6">
                    {trainingStstusData?.ongoing}
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={6}
                  display="flex"
                  direction="row"
                  alignItems="center"
                  gap={1}
                >
                  <Box
                    sx={{
                      bgcolor: "#FABA3A",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                    }}
                  ></Box>
                  <Typography variant="h6">Training Completed</Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    getCardMoreInfo("Training Completed", "completed")
                  }
                >
                  <Typography variant="h6">
                    {trainingStstusData?.training_completed}
                  </Typography>
                </Grid>
              </Grid>
            </NewCardcomp>
          </Grid>
        )}
      </Grid>

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          <EnrollDetails
            SelectedCardData={SelectedCardData}
          
            selectedFilter="default"
          />
        }
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
